<script setup lang="ts">
import { ref } from "vue";
import { api } from "../lib/api.js";
import { useBoard } from "../stores/board.js";
import type { User } from "@shared/types.js";
import type { UserSettings } from "@shared/settings.js";

const board = useBoard();
const username = ref("");
const password = ref("");
const error = ref("");
const busy = ref(false);

async function submit(): Promise<void> {
  error.value = "";
  busy.value = true;
  try {
    const { user, settings } = await api.post<{ user: User; settings: UserSettings }>("/api/login", {
      username: username.value,
      password: password.value,
    });
    await board.start(user, settings);
  } catch (err) {
    error.value = (err as Error).message;
    password.value = "";
  } finally {
    busy.value = false;
  }
}
</script>

<template>
  <div class="login">
    <form @submit.prevent="submit">
      <h1><img src="/favicon.svg" alt="" />todos</h1>
      <input v-model="username" placeholder="username" autocomplete="username" autofocus />
      <input v-model="password" type="password" placeholder="password" autocomplete="current-password" />
      <p class="error">{{ error }}</p>
      <button class="btn primary" :disabled="busy || !username || !password">
        {{ busy ? "…" : "Sign in" }}
      </button>
    </form>
  </div>
</template>
